import React from "react";
import { TableRow, TableCell, Skeleton } from "@mui/material";

// Shared skeleton rows for every Assessment content table, shown while a
// store's getAll() promise is still resolving (see assessmentLocalStore.js).
function AssessmentTableSkeleton({ columns, rows = 6 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow key={`skeleton-row-${rowIndex}`}>
          {Array.from({ length: columns }).map((__, colIndex) => (
            <TableCell key={colIndex} sx={{ padding: "10px 12px" }}>
              <Skeleton variant="text" width={colIndex === 0 ? "80%" : "55%"} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

export default AssessmentTableSkeleton;
